export interface Comment {
  id: string;
  articleId: string;
  userName: string;
  userHandle: string;
  avatarBg: string;
  content: string;
  likes: number;
  time: string;
}

export const comments: Comment[] = [
  {
    id: "c1",
    articleId: "1",
    userName: "八卦小能手",
    userHandle: "@bagua_master",
    avatarBg: "bg-primary-400",
    content: "我就说那天看他状态不对，原来是有情况了！这个圈子真的太精彩了，每天都有新瓜吃不完。",
    likes: 2340,
    time: "2小时前",
  },
  {
    id: "c2",
    articleId: "1",
    userName: "娱乐圈观察员",
    userHandle: "@yule_observer",
    avatarBg: "bg-accent-400",
    content: "作为一个在圈内混了十年的人，我只能说：有些事情远比你们看到的复杂。这位男星的团队现在应该急疯了。",
    likes: 1890,
    time: "3小时前",
  },
  {
    id: "c3",
    articleId: "1",
    userName: "吃瓜不吐籽",
    userHandle: "@chigua_seed",
    avatarBg: "bg-secondary-400",
    content: "哈哈哈哈习惯了，每个月都有一个男星塌房，这次轮到谁了？不过说实话，如果是真的，代言的品牌方估计要哭死了。",
    likes: 1560,
    time: "4小时前",
  },
  {
    id: "c4",
    articleId: "1",
    userName: "真相只有一个",
    userHandle: "@truth_seeker",
    avatarBg: "bg-primary-500",
    content: "别急着下定论，现在只是拍到同进同出，又没有实锤。万一是朋友呢？虽然我也觉得大概率是真的哈哈哈。",
    likes: 920,
    time: "5小时前",
  },
  {
    id: "c5",
    articleId: "1",
    userName: "娱乐至死",
    userHandle: "@entertainment_4ever",
    avatarBg: "bg-accent-500",
    content: "这位男星之前不是还在综艺上说自己是母胎单身吗？如果是真的，这波打脸也太狠了吧，啧啧啧。",
    likes: 1320,
    time: "6小时前",
  },
  {
    id: "c6",
    articleId: "1",
    userName: "理性吃瓜人",
    userHandle: "@rational_eater",
    avatarBg: "bg-secondary-500",
    content: "不管真假，偷拍人家隐私也不对吧。虽然我也爱看八卦，但还是要有点底线，希望51吃瓜网能保持客观公正的态度。",
    likes: 780,
    time: "7小时前",
  },
  {
    id: "c7",
    articleId: "2",
    userName: "团粉永不灭",
    userHandle: "@group_fan_forever",
    avatarBg: "bg-primary-400",
    content: "看到这些截图我真的心碎了。追了她们五年，没想到私下关系这么复杂。不过我还是选择相信她们能处理好。",
    likes: 3450,
    time: "1小时前",
  },
  {
    id: "c8",
    articleId: "2",
    userName: "内娱清醒人",
    userHandle: "@sober_fan",
    avatarBg: "bg-accent-400",
    content: "聊天记录这东西，真真假假谁知道？而且就算是真的，谁私下没吐槽过同事啊，我觉得没必要上纲上线。",
    likes: 2100,
    time: "2小时前",
  },
  {
    id: "c9",
    articleId: "2",
    userName: "律师函警告",
    userHandle: "@lawyer_warning",
    avatarBg: "bg-secondary-400",
    content: "这个泄露聊天记录的人已经违法了。不过作为吃瓜群众，我还是要说：多发点，我爱看。",
    likes: 5670,
    time: "3小时前",
  },
];

export const getCommentsByArticleId = (articleId: string): Comment[] => {
  return comments.filter(c => c.articleId === articleId);
};